export { default as liveIndicatorTemplate } from './live-indicator.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/live-indicator/templates/index.ts